import {IconProps} from "../../types/types";

export default function DeleteRoundIcon({height = 21,width=20, color = "var(--matchid-error-color)",...props}:IconProps) {
    return <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect y="0.5" width="20" height="20" rx="10" fill={color}/>
        <path d="M7.17139 7.67188L12.8282 13.3287" stroke="white" strokeLinecap="round"/>
        <path d="M12.8286 7.67188L7.17176 13.3287" stroke="white" strokeLinecap="round"/>
    </svg>

}